(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('organo-relevante', {
            parent: 'entity',
            url: '/organo-relevante?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organoRelevante.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo-relevante/organo-relevantes.html',
                    controller: 'OrganoRelevanteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organoRelevante');
                    $translatePartialLoader.addPart('tipoOrganoRelevante');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('organo-relevante-detail', {
            parent: 'organo-relevante',
            url: '/organo-relevante/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organoRelevante.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-detail.html',
                    controller: 'OrganoRelevanteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organoRelevante');
                    $translatePartialLoader.addPart('tipoOrganoRelevante');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OrganoRelevante', function($stateParams, OrganoRelevante) {
                    return OrganoRelevante.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'organo-relevante',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('organo-relevante-detail.edit', {
            parent: 'organo-relevante-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-dialog.html',
                    controller: 'OrganoRelevanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrganoRelevante', function(OrganoRelevante) {
                            return OrganoRelevante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo-relevante.new', {
            parent: 'organo-relevante',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-dialog.html',
                    controller: 'OrganoRelevanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('organo-relevante', null, { reload: 'organo-relevante' });
                }, function() {
                    $state.go('organo-relevante');
                });
            }]
        })
        .state('organo-relevante.edit', {
            parent: 'organo-relevante',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-dialog.html',
                    controller: 'OrganoRelevanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrganoRelevante', function(OrganoRelevante) {
                            return OrganoRelevante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo-relevante', null, { reload: 'organo-relevante' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo-relevante.delete', {
            parent: 'organo-relevante',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-delete-dialog.html',
                    controller: 'OrganoRelevanteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OrganoRelevante', function(OrganoRelevante) {
                            return OrganoRelevante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo-relevante', null, { reload: 'organo-relevante' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
